// useTestimonials — fetches published testimonials.
import axios from "axios";
import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cache = { data: null, loaded: false };

export function useTestimonials() {
    const [items, setItems] = useState(() => cache.data || []);
    const [loaded, setLoaded] = useState(() => cache.loaded);

    useEffect(() => {
        if (cache.loaded) return;
        let cancelled = false;
        axios
            .get(`${API}/testimonials`)
            .then((res) => {
                if (cancelled) return;
                cache.data = res.data || [];
                cache.loaded = true;
                setItems(cache.data);
                setLoaded(true);
            })
            .catch(() => {
                if (!cancelled) setLoaded(true);
            });
        return () => { cancelled = true; };
    }, []);

    return { items, loaded };
}

export function invalidateTestimonials() {
    cache.data = null;
    cache.loaded = false;
}
